// core
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// workspace
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MaterialModule } from '@campfire-nx/material';

// modules
import { AppRoutingModule } from './app-routing.module';


// components
import { AppComponent } from './app.component';

// services
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';

// environment
import { environment } from '@open-portal-env';

const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule
  ],
  providers: [
    httpInterceptorProviders,
    // turn ripple off globally
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true }},
    { provide: 'environment', useValue: environment }
  ],
  bootstrap: [AppComponent],
  exports: [MaterialModule]
})
export class AppModule { }

